<template>
    
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b]">Payslip Starting Year 2025</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Employee Page /  Payslip Search</p>
    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        <div class="mt-2">
            <div class="grid grid-cols-11 w-full gap-3 mb-5">
                <input type="text" @input="isTyping = true, search = search.toUpperCase()" placeholder="Search" class="col-span-3 border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm" v-model="search">
                <!-- <select class="col-span-1 border-[#b7b8b7] border  rounded-md   outline-none  text-[#535353] text-center text-sm">
                    <option value="01"> January</option>
                    <option value="02"> Feb</option>
                    <option value="03"> March</option>
                    <option value="04"> April</option>
                </select>
                <select class="col-span-1 border-[#b7b8b7] border  rounded-md   outline-none  text-[#535353] text-center text-sm">
                    <option value="2021"> 2021</option>
                    <option value="2022"> 2022</option>
                    <option value="2023"> 2023</option>
                    <option value="2024"> 2024</option>
                     <option value="2024"> 2025</option>
                </select> -->
            </div>
            <div class=" bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl :Action="true" @toggle-favorite="receiveEmit" @ViewButton="Viewbutton" :column="column" :tablename="tablename" :header="header" VButton="true" :info="info" :DButton="false" :EButton="flase" />
            </div>
        </div>
    </div>
    <Modal @outside="outsidemodal" @confirmation="test" v-if="modal"/>

    <div v-if="Payroll" >
        <PayrollModal :Data="dataPayroll" @close="Payroll = false" :PayData="paydesc" @viewPDF="viewPDF"/>
    </div>
  
</template>

<script>
import _ from 'lodash';
import { defineComponent } from 'vue';
import TableControl from '../controls/TableControl/TableControl.vue'
import Modal from '../controls/modal/ModalSample.vue'
import PayrollModal from '../controls/modal/PayrollModal.vue'
import Services from '../../services/admin'
import PaySlip from '../../services/payslip'
export default defineComponent({
    components:{
        TableControl,
        Modal,
        PayrollModal
    },
    data(){
            return{
                isTyping: false,
                search:'',
                dataPayroll: '',
                Payroll: false,
                error:'',
                modal: false,
                tablename: "tablenamep",
                info:'',
                header:[
                {
                    id: 1,
                    label: 'NoofItems',
                    title: 'No.',
                    visible: true
                },
                {
                    id: 2,
                    label: 'Employee ID',
                    title: 'Employee ID',
                    visible: true
                },
                {
                    id: 3,
                    label: 'Employee',
                    title: 'Employee',
                    visible: true
                },
                {
                    id: 4,
                    label: 'Pay Month',
                    title: 'Pay Month',
                    visible: true
                },
                {
                    id: 4,
                    label: 'Pay Year',
                    title: 'Pay Year',
                    visible: true
                },
                {
                    id: 5,
                    label: 'Action',
                    title: 'Action',
                    visible: true
                }
                ],
                column:[
                    'index',
                    'employee_id',
                    'employee_name',
                    'pay_month',
                    'pay_year',
                ],
                paydesc:'',
            }
        },
        watch: {
            search: _.debounce(function() {
                this.isTyping = false;
            }, 600),
            isTyping: function(value) {
                if (!value) {
                    this.getPaySearch()
                }
            }
        },
        mounted(){
            this.getPayroll()
        },
        methods: {
            async getPayroll(){
                this.$emit("showLoader")
                let that = this
                
                await PaySlip.getPayslip(this.search).then(function(response){
                    that.info = response.data.data
                });
                // const success = await Services.getPayroll(this.search);
                // this.info = success.data

                // const paydesc = await Services.getPayDesc()
                // this.paydesc  = paydesc.data

                this.$emit("hideLoader")
            },
            async getPaySearch(){
                let that = this
                await PaySlip.getPayslip(this.search).then(function(response){
                    that.info = response.data.data
                });
            },
            receiveEmit() {
                this.modal = true
            },
            test(){
                this.modal = false  
            },
            outsidemodal(){
                this.modal = false  
            },
            Viewbutton(Data){
                this.Payroll = true 
                this.dataPayroll = Data
            },
            async viewPDF(name,word,pay15,pay30,netpay,earn,ded,info ){
                let state = this.$store.state
                this.$emit("showLoader")
                await Services.getPdfpayroll(name,word,pay15,pay30,netpay,earn,ded,info, state.pay_desc.paycode, state.pay_desc.dedcode);
                this.$emit("hideLoader")

            }
        },
})
</script>



